import React from 'react';
import { QuizOption } from '../../types';
import ChapterSelection from './ChapterSelection';

interface SubjectSelectionProps {
  selectedExam: string;
  subjectOptions: QuizOption[];
  chapterOptions: QuizOption[];
  selectedSubjects: string[];
  selectedChapters: string[];
  loadingSubjects: boolean;
  loadingChapters: boolean;
  expandedSubjects: Set<string>;
  examSubjectMapping: Record<string, string[]>;
  onSubjectChange: (subjectId: string) => void;
  onChapterChange: (chapterId: string) => void;
  onToggleSubjectExpansion: (subjectId: string) => void;
  onSelectAllChapters: (subjectId: string, checked: boolean) => void;
  isSubjectFullySelected: (subjectId: string) => boolean;
  isSubjectPartiallySelected: (subjectId: string) => boolean;
}

const SubjectSelection: React.FC<SubjectSelectionProps> = ({
  selectedExam,
  subjectOptions,
  chapterOptions,
  selectedSubjects,
  selectedChapters,
  loadingSubjects,
  loadingChapters,
  expandedSubjects,
  examSubjectMapping,
  onSubjectChange,
  onChapterChange,
  onToggleSubjectExpansion,
  onSelectAllChapters,
  isSubjectFullySelected,
  isSubjectPartiallySelected
}) => {
  // Filter subjects based on selected exam
  const getFilteredSubjects = () => {
    if (!selectedExam) {
      return []; // No subjects if no exam selected
    }
    
    const allowedSubjectIds = examSubjectMapping[selectedExam];
    if (!allowedSubjectIds) {
      // If exam not in mapping, show all subjects (fallback)
      return subjectOptions;
    }
    
    // Filter subjects based on mapping
    return subjectOptions.filter(subject => 
      allowedSubjectIds.includes(subject.value)
    );
  };

  return (
    <div className="mb-4">
      <label className="form-label fw-semibold">
        <i className="fas fa-sitemap me-2 text-primary"></i>
        Select Content <span className="text-danger">*</span>
      </label>

      {loadingSubjects ? (
        <div className="text-center py-3">
          <span className="spinner-border spinner-border-sm me-2"></span>
          Loading subjects...
        </div>
      ) : (
        <div className="border rounded-3 p-3" style={{ backgroundColor: '#f8f9fa' }}>
          {/* Subjects */}
          <div className="mb-3">
            <h6 className="fw-semibold mb-3">
              <i className="fas fa-book me-2 text-primary"></i>
              Subjects
            </h6>
            <div className="row g-2">
              {getFilteredSubjects().length > 0 ? (
                getFilteredSubjects().map(subject => (
                  <div key={subject.value} className="col-12">
                    <div className="card border-0 shadow-sm h-100">
                      <div className="card-body p-3">
                        <div className="d-flex align-items-center justify-content-between">
                          <div className="form-check flex-grow-1">
                            <input
                              className="form-check-input"
                              type="checkbox"
                              id={`subject-${subject.value}`}
                              checked={selectedSubjects.includes(subject.value)}
                              onChange={() => onSubjectChange(subject.value)}
                            />
                            <label className="form-check-label fw-medium ms-2" htmlFor={`subject-${subject.value}`}>
                              {subject.label}
                            </label>
                          </div>
                          
                        </div>
                        
                        
                        
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <div className="col-12">
                  <div className="alert alert-info border-0" style={{ borderRadius: '12px', backgroundColor: '#e3f2fd' }}>
                    <div className="d-flex align-items-center">
                      <i className="fas fa-info-circle text-primary me-2"></i>
                      <span className="text-primary">
                        <strong>No subjects available</strong> for the selected exam or the exam-subject mapping needs to be configured.
                      </span>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubjectSelection;